import PageHeader from '@/components/page-header'
import PendingModule from '@/components/pending-module'
import DefinitionList from '@/components/definition-list'
import { useAuth } from '@/utility/context/auth-context'
import { formatTelefone, orDash } from '@/utility/Utils'
import styles from './style.module.css'

const Configuracoes = () => {
  const { user } = useAuth()

  return (
    <>
      <PageHeader title="Configurações" subtitle="Seus dados de acesso ao Admin IntegraDoor" />

      <div className={styles.wrapper}>
        <DefinitionList
          title="Minha conta"
          items={[
            { label: 'Nome', value: orDash(user?.nomeUsuario) },
            { label: 'E-mail', value: orDash(user?.email) },
            { label: 'Perfil', value: orDash(user?.perfil) },
            { label: 'Telefone', value: formatTelefone(user?.phoneNumber, user?.countryCode) },
            { label: 'Verificação em duas etapas', value: user?.usa2FA ? 'Ativa' : 'Inativa' },
          ]}
        />

        <PendingModule
          descricao="Os dados acima vêm do token da sessão. A edição ainda não está ligada."
          dependencias={[
            'Trocar senha: POST v2/auth-backoffice/alterar-minha-senha existe na api-backoffice, autenticado e validando a senha atual, falta ligar o formulário',
            'Alterar nome, telefone e foto: POST backoffice/admin-user/atualizar-usuario-admin aceita foto em base64 e grava no Azure Storage, mas só atende perfil Administrador',
            'Equivalente para o perfil Operador: não existe endpoint de edição do próprio perfil',
            'Ligar ou desligar o 2FA pelo próprio usuário: não existe endpoint',
          ]}
          card="IN-2803"
        />
      </div>
    </>
  )
}

export default Configuracoes
